module.exports = __webpack_public_path__ + "static/media/transaction.0debdf7b.svg";